(function () {
  var DATA_URL = window.TC_GUIA_DATA_URL;
  var DATA = null;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchData() {
    if (DATA) return Promise.resolve(DATA);
    return fetch(DATA_URL).then(function (r) { return r.json(); }).then(function (d) { DATA = d; return d; });
  }

  function cardHTML(e, accent) {
    var style = accent ? ' style="border-top-color:' + accent + '"' : '';
    return '<a href="/pages/estilos-de-cervezas/' + e.h + '"' + style + '>' +
      '<b>' + escapeHtml(e.n) + '</b>' +
      '<span>' + escapeHtml(e.sf || '') + ' · ' + escapeHtml(e.e || '') + '</span>' +
      '<span>' + e.am + '–' + e.ax + '% ABV · ' + e.im + '–' + e.ix + ' IBU</span>' +
      '</a>';
  }

  var ACCENTS = { IPA: '#4E8B31', ALE: '#C55A11', SOUR: '#BF8F00', BLACK: '#4A4A4A', LAGER: '#2F5597' };

  // --- Página de familia ---
  document.querySelectorAll('[data-gf-familia]').forEach(function (grid) {
    var familia = grid.getAttribute('data-gf-familia');
    var accent = ACCENTS[familia] || '#111';
    var countEl = document.querySelector('[data-gf-count]');
    fetchData().then(function (data) {
      var items = data.filter(function (e) { return e.f === familia; })
        .sort(function (a, b) { return a.n.localeCompare(b.n, 'es'); });
      grid.innerHTML = items.map(function (e) { return cardHTML(e, accent); }).join('');
      if (countEl) countEl.textContent = items.length;
    });
  });

  // --- Comparador ---
  var root = document.querySelector('[data-gc-root]');
  if (root) {
    var grid = root.querySelector('[data-gc-grid]');
    var countEl = root.querySelector('[data-gc-count]');
    var famChips = root.querySelectorAll('[data-gc-familia]');
    var abvMin = root.querySelector('[data-gc-abv-min]');
    var abvMax = root.querySelector('[data-gc-abv-max]');
    var ibuMin = root.querySelector('[data-gc-ibu-min]');
    var ibuMax = root.querySelector('[data-gc-ibu-max]');
    var escuelaSel = root.querySelector('[data-gc-escuela]');
    var searchInput = root.querySelector('[data-gc-search]');
    var sortSel = root.querySelector('[data-gc-sort]');
    var activeFamilias = {};
    famChips.forEach(function (chip) { activeFamilias[chip.getAttribute('data-gc-familia')] = true; });

    famChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var fam = chip.getAttribute('data-gc-familia');
        if (activeFamilias[fam]) { delete activeFamilias[fam]; chip.classList.remove('is-active'); }
        else { activeFamilias[fam] = true; chip.classList.add('is-active'); }
        render();
      });
    });
    [abvMin, abvMax, ibuMin, ibuMax, escuelaSel, searchInput, sortSel].forEach(function (el) {
      if (el) el.addEventListener('input', render);
    });

    function render() {
      fetchData().then(function (data) {
        var items = data.filter(function (e) { return activeFamilias[e.f]; });
        var aMin = parseFloat(abvMin.value); if (isNaN(aMin)) aMin = 0;
        var aMax = parseFloat(abvMax.value); if (isNaN(aMax)) aMax = 999;
        var iMin = parseFloat(ibuMin.value); if (isNaN(iMin)) iMin = 0;
        var iMax = parseFloat(ibuMax.value); if (isNaN(iMax)) iMax = 999;
        items = items.filter(function (e) { return e.ax >= aMin && e.am <= aMax && e.ix >= iMin && e.im <= iMax; });
        var esc = escuelaSel.value;
        if (esc) items = items.filter(function (e) { return e.e === esc; });
        var q = (searchInput.value || '').trim().toLowerCase();
        if (q) items = items.filter(function (e) {
          return e.n.toLowerCase().indexOf(q) !== -1 || (e.sf || '').toLowerCase().indexOf(q) !== -1;
        });
        var sort = sortSel.value;
        if (sort === 'abv') items.sort(function (a, b) { return a.am - b.am; });
        else if (sort === 'ibu') items.sort(function (a, b) { return a.im - b.im; });
        else items.sort(function (a, b) { return a.n.localeCompare(b.n, 'es'); });
        grid.innerHTML = items.map(function (e) { return cardHTML(e, ACCENTS[e.f]); }).join('') ||
          '<p style="font-size:12px;color:var(--gris);">No hay estilos con estos filtros.</p>';
        if (countEl) countEl.textContent = items.length;
      });
    }
    render();
  }
})();
